import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { supabase } from '@/lib/supabase/client';

export const Route = createFileRoute('/_app/$wsSlug')({
  loader: async ({ params }) => {
    const { data: sessData } = await supabase.auth.getSession();
    const userId = sessData.session?.user.id;
    if (!userId) throw redirect({ to: '/login' });

    const { data: workspace, error } = await supabase
      .from('workspaces')
      .select('id, name, slug, owner_id')
      .eq('slug', params.wsSlug)
      .maybeSingle();
    if (error || !workspace) throw redirect({ to: '/onboarding' });

    const { data: membership } = await supabase
      .from('workspace_members')
      .select('role')
      .eq('workspace_id', workspace.id)
      .eq('user_id', userId)
      .maybeSingle();

    if (!membership && workspace.owner_id !== userId) {
      // Si el user es platform admin (superadmin), permitirlo entrar igual —
      // típicamente accedió desde /admin/workspaces para inspeccionar el WS.
      // Sino, lo mandamos a /onboarding como antes.
      const { data: isAdmin } = await supabase.rpc('is_platform_admin');
      if (!isAdmin) throw redirect({ to: '/onboarding' });
    }

    return {
      workspace,
      // RG-06: si es platform admin sin membership en este workspace, otorgar 'guest'
      // (rol mínimo). El bypass de privilegios platform-admin viene por
      // is_platform_admin() en RLS — no necesita 'owner' en el cliente.
      role: membership?.role ?? 'guest',
    };
  },
  component: WorkspaceLayout,
});

function WorkspaceLayout() {
  return <Outlet />;
}
